import React, { ReactElement } from 'react';
import ListItemInternal from '@mui/material/ListItem';
import FormatService from '../../services/format-service';
import useStylesListItem from './list-item.styles';

const ListItem: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isLight,
    isActive,
    isButton,
    isDefault,
    isExtended,
    isCompleted,
    withContentSpread,
    className,
    onClick,
    onPointerDown,
    onPointerUp,
    onTouchEnd,
    children,
  } = props;

  const { classes } = useStylesListItem();

  const activeClassName: string | undefined = isActive ? classes.listItemActive : undefined;
  const extendedClassName: string | undefined = isExtended ? classes.listItemExtended : undefined;
  const contentSpreadClassName: string | undefined = withContentSpread ? classes.listItemContentSpread : undefined;
  const completedClassName: string | undefined = isCompleted ? classes.listItemCompleted : undefined;
  const buttonClassName: string | undefined = !isLight && !isActive && !isCompleted && isButton
    ? classes.listItemButton : undefined;

  return (
    <ListItemInternal
      button={isButton}
      className={FormatService.formatClassNames(
        !isDefault ? classes.listItem : undefined,
        activeClassName, extendedClassName, contentSpreadClassName, completedClassName, buttonClassName, className,
      )}
      onClick={onClick}
      onPointerDown={onPointerDown}
      onPointerUp={onPointerUp}
      onTouchEnd={onTouchEnd}
    >
      {children}
    </ListItemInternal>
  );
});

export default ListItem;
